var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "unsaved-changes-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "modal-dialog-size": "md",
      "footer-close-button-text": _vm.$t("templates.beePlugin.keepEditing"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("global.words.confirmation")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "pb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("lists.messages.unsavedChangesSegment")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary confirm-segment-tab",
                attrs: { type: "button" },
                on: { click: _vm.handleConfirm },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.phrases.leaveWithoutSaving")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }